import React from "react";
import styled from "styled-components";
import IUMRSNavBar from "./IUMRSNavbar";
import { ICAMNavroute } from "../../../utils/ICAMnavroute";
import IUMRSFooter from "./IUMRSFooter"
import { useDesktopSiteDetection } from "../../../hooks/mobile_desktop_mode";
import head_img from "../../../assets/images/venue_exterior.jpg";
import image1 from "../../../assets/loc-img/venue-interior-hall.jpg";
import image2 from "../../../assets/loc-img/venue-interior-hall2.jpg";
import image3 from "../../../assets/loc-img/venue-interior-room.jpg";
import image4 from "../../../assets/loc-img/venue-interior-seminar.png";
import image5 from "../../../assets/loc-img/venue_front.jpg";
import image6 from "../../../assets/loc-img/venue_front_reception.jpg";
import image7 from "../../../assets/loc-img/pagoda_image.jpg";
import image8 from "../../../assets/loc-img/pagoda_serving.jpg";
import ImageSlider from "../../../hooks/useDoubleImageSlider";
import NotificationDropdown from "../../../hooks/notificationsDropdown";

const ConferenceVenue = () =>{

    const isDesktopSiteOnMobile = useDesktopSiteDetection()
    const centerImages = [ 
        {image: image1, description: "Main Hall"},
        {image: image2, description: "Main Hall"},
        {image: image3, description: "Seminar room"},
        {image: image4, description: "Seminar room"}, 
        ];

    const centerImages2 = [ 
        {image: image5, description: "Entrance"},
        {image: image6, description: "Reception"},
        {image: image7, description: "Pagoda serving station"},
        {image: image8, description: "Pagoda serving station"} 
        ];

    return (
        <Wrapper>
            <IUMRSNavBar navroute={ICAMNavroute}/>
            <NotificationDropdown />
            <IntroBox className={isDesktopSiteOnMobile ? 'desktop-site-mode' : ''}>
            
            <div className="main-field">
                <div className="image-header">
                    <img 
                        className="iumrs2025" 
                        src={head_img}
                        alt="IUMRS Event"
                    />

                    <div className="hero-content-box">                                        
                        <div className="hero-content">
                            <div className="hero-top-content">
                                <p>IUMRS-ICAM 2025 Conference Venue</p>
                            </div>
                                <h4>ISSER Conference Hall, University of Ghana.</h4>
                        </div>
                    </div>
                </div>
                <div className="detail-box">
                    
                    <Map>
                        <div className="google-map">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3970.3986900416276!2d-0.1844652!3d5.6553287999999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xfdf9c86338389a7%3A0x5f71f8b34cfbf267!2sISSER%20Conference%20Hall!5e0!3m2!1sen!2sgh!4v1763989758038!5m2!1sen!2sgh" width="600" height="450" style={{ border: 0}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </Map>
                    
                
                </div>
            </div>
            </IntroBox>

            <Content>
                <div className="header">
                    <h2>EXPLORE THE ISSER CONFERENCE HALL</h2>
                </div>

                <Body className={isDesktopSiteOnMobile ? 'desktop-site-mode' : ''}>
                    <div className="main-text">
                        <p>The ISSER Conference Hall, located in the vibrant city of Accra, Ghana, serves as a versatile venue 
                            for a variety of celebrations and events. This modern facility is designed to accommodate gatherings 
                            of different sizes, making it an ideal choice for hosting different symposia talks concurrently.  
                        </p>
                        <p> The conference hall boasts a main hall with a seating capacity of 300, where keynote addresses and introductory sessions 
                            by our esteemed guest speakers will take place. In addition, the venue includes two equipped meeting rooms, accommodating 
                            between about 35 participants each. These rooms will host the pre-conference workshops as well as the various symposia scheduled throughout the main conference.
                        </p> 

                        <ImageSlider images={centerImages} />
                        
                        <p>Navigating the conference center is straightforward, with clear signage indicating room numbers throughout the facility. The hallways are wide and fully 
                            accessible, including for individuals using wheelchairs, and are maintained to the highest standards of cleanliness. The conference facility center 
                            also large compound with shaded outdoor spaces serving as outdoor refreshment areas or suitable for exhibition displays and informal networking.
                        </p>
                        
                        <ImageSlider images={centerImages2} />
                    </div>
                </Body>
            </Content>

            
            <IUMRSFooter />
        </Wrapper>
    )
}

const Wrapper = styled.div`
`

const Map = styled.div`
    
    width: 90%;
    height: 75%;
    max-width: 500px;
    margin: 0 auto;
    border-radius: 10px;

    .google-map {  
        position: relative;
        height: 100%;
    }

    .google-map iframe {
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
        border: none;
        border-radius: 10px;
    }
`
const IntroBox = styled.div`

    .main-field {
        background-color: #082D4A;
        width: 100%;
        height: 95vh;
        display: flex;
        flex-direction: column;
        animation: heroLoad 2s ease-in-out;
        position: relative;

        @media only screen and (min-width: 450px){
                height: 130vh;
        }

        @media only screen and (min-width: 850px){
                height: 150vh;
        }

        .image-header {
            width: 100%;
            height: 35%;
            position: relative; /* Added to contain the hero content box */
            
            .iumrs2025 {
                width: 100%;
                height: 100%;
                object-fit: cover;
                opacity: 0.9;
            }  
            
            .hero-content-box {
                position: absolute;
                bottom: 10%;
                left: 0;
                width: 80%;
                padding: 1rem 0;
                
                @media only screen and (min-width: 768px) {
                    width: 60%;
                    bottom: 15%;
                }
                
                @media only screen and (min-width: 1000px) {
                    width: 50%;
                    bottom: 10%;
                }
            
                .hero-content{
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    padding: 0 2em;
                    color: #fff;
                    border-radius: 0 5px 5px 0;

                .hero-top-content{
                    display: flex;
                    align-items: center;
                    p{
                        font-size: 0.9rem;
                        font-weight: 400;
                        margin-bottom: 0.3em;
                    }
                }

                h4{
                    font-size: 1.5em; /* Reduced for mobile */
                    margin: 0.2em 0;
                    width: 100%; /* Full width on mobile */
                    font-family: "PT Serif", serif;
                    font-style: normal;
                    font-weight: 600;
                    letter-spacing: .005em;
                    line-height: 1.18;
                    
                    @media only screen and (min-width: 768px) {
                        font-size: 2em;
                        width: 90%;
                    }
                    
                    @media only screen and (min-width: 1000px) {
                        font-size: 2.3em;
                        width: 100%;
                    }
                }
        }
}}

        .detail-box {
            width: 100%;
            height: 65%;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 0px 0;
            overflow: auto;

        }

        @media only screen and (min-width: 450px){
            .image-header {height: 50%;}
            .detail-box {height: 50%;}
            }

        @media only screen and (min-width: 1000px) {
            flex-direction: row;
            height: 77.5vh;

            .image-header {
                width: 60%;
                height: 100%;
                
                .iumrs2025 {
                    object-fit: cover;
                }
            }

            .detail-box {
                width: 40%;
                height: 100%;
                align-items: center;
                justify-content: center;
            }
        }
    }

    @keyframes heroLoad{
        from{
            clip-path: polygon(0 0, 100% 0, 100% 0, 0 0);
        }
        to{
            clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
        }
    }

    &.desktop-site-mode{
        .main-field {
            height: 30vh;
            flex-direction: row;

            .image-header {
                width: 60%;
                height: 100%;
                
                .iumrs2025 {
                    object-fit: cover;
                }
                
                .hero-content-box {
                    bottom: 20%;
                    width: 60%;
                }
            }

            .detail-box {
                width: 40%;
                height: 100%;
                align-items: center;
                justify-content: center;
            }
        }
    }

`

const Content = styled.div`
    font-family: "Noto Serif", serif;
    font-weight: 300;

    .header {
    width: 100%;
    margin: 3rem 0 0 0;
    text-align: center;
    
    h2 {
        margin: 0 auto;
        color: #CA9D3B;
        max-width: 90%;
        font-size: 1.8em;
    }
  }

   @media only screen and (min-width: 800px) {
        .header{
            margin-bottom: 3rem;
            h2{font-size: 2.5rem;}
        }
    }

`
const Body = styled.div`
margin: 2em 2em 1em 2em;

    p{
        color:  rgb(97, 96, 96);
        line-height: 1.8em;
        font-size: 1.1em;
    }

    .main-text: {text-align: justify}

    .intro-text {
        width: 100%;
        display: flex;
        justify-content: center;
        text-align: center;
        margin-bottom: 1.5rem;

        span{
            color:  #082D4A;
            font-weight: 600;
            font-size: 1.7rem;
        }
        
        
        p {
            max-width: 90%;
            
            
        }
    }

    .heading {
        color: #082D4A;
        font-weight: 500;
    }

    @media only screen and (min-width: 800px) {
        margin: 0em 3em 1em 3em;

        .intro-text {margin-top: 3rem;}
    }

    @media only screen and (min-width: 1000px) {
        width: 56em;
        margin: 0 auto;
    }

    &.desktop-site-mode {
        
        .main-text{
            margin: 0.5em;
            
            p {
                font-size: 0.65em;
                line-height: 1.5em;
            }
        }
        
        .intro-text span {
            font-size: 2em;
        }
        
        .heading {
            font-size: 0.9em;
        }
    }
 `

export default ConferenceVenue;